export default "__VITE_ASSET__CGWeg5zl__"